module.exports = __webpack_public_path__ + "img/IMG_9000_L_WoodMatted.b9bd6b12.jpg";